var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProsp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 194,
    viewBox: "0 0 200 194",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4_11",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 200,
    height: 194
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200 0.41526H0V194H200V0.41526Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.858 103.9C181.858 103.9 145.728 153.88 129.248 176.497C112.463 199.533 87.2369 199.527 70.4416 176.474C53.3536 153.017 18.1417 103.9 18.1417 103.9C18.1417 103.9 31.3198 113.374 38.2485 114.136C51.0753 115.546 62.2243 110.007 71.4171 97.5788C80.4818 85.3227 91.5931 70.1682 100 56.7756C109.314 71.6695 120.375 87.1511 130.99 100.295C144.027 114.136 157.57 117.997 172.93 110.328C175.28 109.155 179.563 105.278 181.858 103.9Z",
    fill: "#6039DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0411 114.621C19.3245 114.621 0 87.8593 0 56.7753C0 25.6914 19.3245 0.492887 42.0411 0.492887C66.8182 -2.00855 100 56.7753 100 56.7753C100 56.7753 74.3179 114.621 42.0411 114.621Z",
    fill: "#9168F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.958 114.621C180.675 114.621 200 87.8593 200 56.7753C200 25.6914 180.675 0.492887 157.958 0.492887C133.182 -2.00855 99.9998 56.7753 99.9998 56.7753C99.9998 56.7753 125.682 114.621 157.958 114.621Z",
    fill: "#52B5F9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProsp);
export default __webpack_public_path__ + "static/media/prosp.4975dabfb6b9a7c0aff1d119ba4bb121.svg";
export { ForwardRef as ReactComponent };